import _ from 'lodash';
import { VendorEleFileConfigFieldEnum as EleFileConfigFields } from 'Common/FieldEnum';
import { VendorFieldEnum as Fields } from 'Common/FieldEnum';
import { VendorElectronicFileTypesEnum as FileTypes } from 'Common/Constants/Enumeration/VendorElectronicFileTypesEnum';

export const vendorInitialValues = values => {
  const poZip =
    values.POZip &&
    (values.POZip.length <= 5
      ? values.POZip.substr(0, 5)
      : values.POZip.substr(0, 5) + '-' + values.POZip.substr(5));
  const remitZip =
    values.RemitZip &&
    (values.RemitZip.length <= 5
      ? values.RemitZip.substr(0, 5)
      : values.RemitZip.substr(0, 5) + '-' + values.RemitZip.substr(5));
  return {
    [Fields.Id]: values.Id,
    [Fields.VendorNum]: values.VendorNum,
    [Fields.FederalId]: values.FederalId,
    [Fields.Description]: values.Description,
    [Fields.POAddress1]: values.POAddress1,
    [Fields.POAddress2]: values.POAddress2,
    [Fields.POZip]: poZip,
    [Fields.POState]: values.POState,
    [Fields.POCity]: values.POCity,
    [Fields.POPhone]:
      values.POPhone &&
      '(' +
        values.POPhone.substr(0, 3) +
        ') ' +
        values.POPhone.substr(3, 3) +
        '-' +
        values.POPhone.substr(6, 4),

    [Fields.POFax]:
      values.POFax &&
      '(' +
        values.POFax.substr(0, 3) +
        ') ' +
        values.POFax.substr(3, 3) +
        '-' +
        values.POFax.substr(6, 4),
    [Fields.POEmail]: values.POEmail,
    [Fields.IsPOAddSameAsRemittance]: values.IsPOAddSameAsRemittance,
    [Fields.RemitAddress1]: values.RemitAddress1,
    [Fields.RemitAddress2]: values.RemitAddress2,
    [Fields.RemitZip]: remitZip,
    [Fields.RemitState]: values.RemitState,
    [Fields.RemitCity]: values.RemitCity,
    [Fields.RemitPhone]:
      values.RemitPhone &&
      '(' +
        values.RemitPhone.substr(0, 3) +
        ') ' +
        values.RemitPhone.substr(3, 3) +
        '-' +
        values.RemitPhone.substr(6, 4),
    [Fields.Display]: values.Display,
    [Fields.IsWarehouseOrKitchen]: values.IsWarehouseOrKitchen,
    [Fields.IsDOD]: values.IsDOD,
  };
};

export const vendorSubmitValues = values => {
  return {
    [Fields.Id]: values.Id,
    [Fields.VendorNum]: values.VendorNum,
    [Fields.FederalId]: values.FederalId,
    [Fields.Description]: values.Description,
    [Fields.POAddress1]: values.POAddress1,
    [Fields.POAddress2]: values.POAddress2,
    [Fields.POZip]:
      values.POZip && values.POZip.length > 0
        ? values.POZip.replace(/[^a-z0-9]+/g, '')
        : '',
    [Fields.POState]: values.POState,
    [Fields.POCity]: values.POCity,
    [Fields.POPhone]:
      values[Fields.POPhone] && values[Fields.POPhone].length > 0
        ? values[Fields.POPhone].replace(/[^a-z0-9]+/g, '')
        : '',
    [Fields.POFax]:
      values[Fields.POFax] && values[Fields.POFax].length > 0
        ? values[Fields.POFax].replace(/[^a-z0-9]+/g, '')
        : '',
    [Fields.POEmail]: values.POEmail,
    [Fields.IsPOAddSameAsRemittance]: values.IsPOAddSameAsRemittance,
    [Fields.RemitAddress1]: values.RemitAddress1,
    [Fields.RemitAddress2]: values.RemitAddress2,
    [Fields.RemitZip]:
      values.RemitZip && values.RemitZip.length > 0
        ? values.RemitZip.replace(/[^a-z0-9]+/g, '')
        : '',
    [Fields.RemitState]: values.RemitState,
    [Fields.RemitCity]: values.RemitCity,
    [Fields.RemitPhone]:
      values[Fields.RemitPhone] && values[Fields.RemitPhone].length > 0
        ? values[Fields.RemitPhone].replace(/[^a-z0-9]+/g, '')
        : '',
    [Fields.Display]: values.Display,
    [Fields.IsWarehouseOrKitchen]: values.IsWarehouseOrKitchen,
    [Fields.IsDOD]: values.IsDOD,
  };
};

export const vendorEleFileConfigInitialValues = (values, vendorId) => {
  return {
    [EleFileConfigFields.Id]:
      values[EleFileConfigFields.InvVFFHeaderInfoModel][EleFileConfigFields.Id],
    [EleFileConfigFields.VendorId]: vendorId,
    [EleFileConfigFields.FileFormat]: values[
      EleFileConfigFields.InvVFFHeaderInfoModel
    ][EleFileConfigFields.FileFormat]
      ? values[EleFileConfigFields.InvVFFHeaderInfoModel][
          EleFileConfigFields.FileFormat
        ]
      : FileTypes.FixedLength,
    [EleFileConfigFields.InvVFFFieldInfoModel]:
      values[EleFileConfigFields.InvVFFFieldInfoModel],
    [EleFileConfigFields.FileFields]:
      values[EleFileConfigFields.InvVFFDetailModel],
    [EleFileConfigFields.SiteId]: values[EleFileConfigFields.SiteId],
    [EleFileConfigFields.CustomerInfo]:
      values[EleFileConfigFields.InvVFFCustomerInfoModel],
  };
};

export const vendorEleFileConfigSubmitValues = values => {
  const fields =
    values[EleFileConfigFields.FileFormat] === FileTypes.USFOOD ||
    values[EleFileConfigFields.FileFormat] === FileTypes.SYSCO
      ? []
      : _.map(values[EleFileConfigFields.FileFields], field => {
          return {
            [EleFileConfigFields.HeaderId]: values[EleFileConfigFields.Id],
            [EleFileConfigFields.FieldInfoId]:
              field[EleFileConfigFields.FieldInfoId],
            [EleFileConfigFields.IdLength]: field[EleFileConfigFields.IdLength],
            [EleFileConfigFields.OrderId]: field[EleFileConfigFields.OrderId],
          };
        });
  return {
    [EleFileConfigFields.InvVFFHeaderInfoModel]: {
      [EleFileConfigFields.Id]: values[EleFileConfigFields.Id],
      [EleFileConfigFields.VendorId]: Number(
        values[EleFileConfigFields.VendorId]
      ),
      [EleFileConfigFields.FileFormat]: values[EleFileConfigFields.FileFormat],
    },
    [EleFileConfigFields.InvVFFDetailModel]: fields,
    [EleFileConfigFields.InvVFFCustomerInfoModel]: _.map(
      values[EleFileConfigFields.CustomerInfo],
      field => {
        return {
          [EleFileConfigFields.VendorId]: Number(
            values[EleFileConfigFields.VendorId]
          ),
          [EleFileConfigFields.SiteId]: field[EleFileConfigFields.SiteId],
          [EleFileConfigFields.VendorsSiteId]:
            field[EleFileConfigFields.VendorsSiteId],
          [EleFileConfigFields.VendorsContractId]:
            field[EleFileConfigFields.VendorsContractId],
        };
      }
    ),
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/helpers/index.js